import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { SignUp_Actionn } from '../../Redux/Actions/AuthAction';
import { GetAllchannalData } from '../../Redux/Actions/ChannalActions';
import { Notify } from '../../Utility/Notify';
import { useSidebarWidth } from '../../Utility/useSidebarWidth';

/* ─── Icons ──────────────────────────────────────────────────────────────── */
const IconPerson  = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>;
const IconMail    = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>;
const IconPhone   = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 9.91a16 16 0 0 0 6.16 6.16l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>;
const IconLock    = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>;
const IconEye     = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>;
const IconEyeOff  = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>;
const IconBadge   = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>;
const IconCamera  = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>;
const IconX       = () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
const IconChevron = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="6 9 12 15 18 9"/></svg>;
const IconCheck   = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>;
const IconNumbers = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="4" y1="9" x2="20" y2="9"/><line x1="4" y1="15" x2="20" y2="15"/><line x1="10" y1="3" x2="8" y2="21"/><line x1="16" y1="3" x2="14" y2="21"/></svg>;
const IconChannel = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"/></svg>;
const IconArrow   = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="9 18 15 12 9 6"/></svg>;
const IconSearch  = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>;

const ROLE_DATA = [
  { name: 'Admin',       icon: '👨‍💼', color: '#ef4444' },
  { name: 'Manager',     icon: '👔',  color: '#3b82f6' },
  { name: 'Sales',       icon: '💰',  color: '#22c55e' },
  { name: 'Team Leader', icon: '👥',  color: '#f59e0b' },
  { name: 'Marketer',    icon: '📢',  color: '#a855f7' },
  { name: 'Accountant',  icon: '📊',  color: '#64748b' },
];

/* ─── CSS ────────────────────────────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&display=swap');
  @keyframes rg-fade { from{opacity:0;transform:translateY(10px)} to{opacity:1;transform:translateY(0)} }
  @keyframes rg-spin  { to{transform:rotate(360deg)} }
  .rg-card { animation: rg-fade 0.3s ease both; }
  .rg-input {
    width:100%; padding:11px 14px 11px 40px; border-radius:10px; font-size:13px;
    font-family:'DM Sans',sans-serif; outline:none; box-sizing:border-box;
    transition:border-color 0.15s, box-shadow 0.15s;
  }
  .rg-input:focus { border-color:#1d4ed8 !important; box-shadow:0 0 0 3px rgba(29,78,216,0.1); }
  .rg-label { font-size:11px; font-weight:700; letter-spacing:0.07em; text-transform:uppercase; display:block; margin-bottom:7px; }
  .rg-section { animation: rg-fade 0.35s ease both; }
  .rg-chip {
    display:inline-flex; align-items:center; gap:5px; padding:4px 10px 4px 12px;
    border-radius:20px; font-size:12px; font-weight:600; transition:all 0.15s;
  }
  .rg-channel-opt {
    padding:10px 14px; font-size:13px; cursor:pointer; display:flex;
    align-items:center; justify-content:space-between;
    transition:background 0.1s; font-family:'DM Sans',sans-serif;
  }
  .rg-channel-opt:hover { background:rgba(168,85,247,0.06); }
  .rg-spin { width:16px;height:16px;border-radius:50%;border:2px solid rgba(255,255,255,0.35);border-top-color:#fff;animation:rg-spin 0.7s linear infinite;display:inline-block; }
  .rg-chan-scroll::-webkit-scrollbar { width:4px; }
  .rg-chan-scroll::-webkit-scrollbar-track { background:transparent; }
  .rg-chan-scroll::-webkit-scrollbar-thumb { background:rgba(168,85,247,0.3); border-radius:4px; }
`;

let cssInjected = false;
const injectCSS = () => {
  if (cssInjected) return; cssInjected = true;
  const el = document.createElement('style'); el.innerHTML = CSS; document.head.appendChild(el);
};

/* ─── Field ──────────────────────────────────────────────────────────────── */
const Field = ({ label, icon: Icon, children, isDark }) => (
  <div>
    <label className="rg-label" style={{ color: isDark ? '#6b7280' : '#94a3b8' }}>{label}</label>
    <div style={{ position: 'relative' }}>
      <span style={{ position:'absolute', left:13, top:'50%', transform:'translateY(-50%)', color:isDark?'#4b5563':'#94a3b8', display:'flex', pointerEvents:'none' }}>
        <Icon />
      </span>
      {children}
    </div>
  </div>
);

/* ─── Section Header ─────────────────────────────────────────────────────── */
const SectionHeader = ({ icon: Icon, iconColor, title, isDark }) => (
  <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:20 }}>
    <div style={{ width:32, height:32, borderRadius:9, background:isDark?`rgba(${iconColor},0.12)`:`rgba(${iconColor},0.08)`, border:`1px solid rgba(${iconColor},0.2)`, display:'flex', alignItems:'center', justifyContent:'center', color:`rgb(${iconColor})`, flexShrink:0 }}>
      <Icon />
    </div>
    <span style={{ fontSize:14, fontWeight:700, color:isDark?'#f1f5f9':'#0d1b3e' }}>{title}</span>
  </div>
);

/* ─── Main ───────────────────────────────────────────────────────────────── */
export const Rigister = () => {
  injectCSS();
  const theme        = useTheme();
  const isDark       = theme.palette.mode === 'dark';
  const dispatch     = useDispatch();
  const sidebarWidth = useSidebarWidth();

  const [formData, setFormData]                 = useState({ name:'', email:'', phone:'', password:'', confirmPassword:'', role:'' });
  const [image, setImage]                       = useState(null);
  const [selectedFile, setSelectedFile]         = useState('');
  const [selectedChannels, setSelectedChannels] = useState([]);
  const [channels, setChannels]                 = useState([]);
  const [loading, setLoading]                   = useState(false);
  const [channelsLoading, setChannelsLoading]   = useState(false);
  const [requestedLeadsLimit, setReqLimit]      = useState(100);
  const [showPass, setShowPass]                 = useState(false);
  const [showConfirm, setShowConfirm]           = useState(false);
  const [focused, setFocused]                   = useState(null);
  const [roleOpen, setRoleOpen]                 = useState(false);
  const [chanOpen, setChanOpen]                 = useState(false);
  const [chanSearch, setChanSearch]             = useState('');

  const ressignup        = useSelector((s) => s.AuthRoot?.Signup);
  const resgetallchannal = useSelector((s) => s.AllChannalRoot?.channal);

  const C = {
    bg:      isDark ? '#0f1117' : '#f4f6f9',
    card:    isDark ? '#1a1f2e' : '#ffffff',
    border:  isDark ? '#252d45' : '#e8edf5',
    text:    isDark ? '#f1f5f9' : '#0d1b3e',
    sub:     isDark ? '#6b7280' : '#94a3b8',
    inputBg: isDark ? '#131929' : '#f8fafc',
    inBdr:   isDark ? '#252d45' : '#e2e8f0',
  };

  const inputStyle = (name) => ({
    border: `1.5px solid ${focused===name ? '#1d4ed8' : C.inBdr}`,
    background: C.inputBg, color: C.text,
    boxShadow: focused===name ? '0 0 0 3px rgba(29,78,216,0.1)' : 'none',
  });

  const handleInput = (field) => (e) => setFormData(p => ({ ...p, [field]: e.target.value }));

  const handleImage = (e) => {
    if (e.target.files?.[0]) {
      setImage(URL.createObjectURL(e.target.files[0]));
      setSelectedFile(e.target.files[0]);
    }
  };

  const handleRole = (roleName) => {
    setFormData(p => ({ ...p, role: roleName }));
    setRoleOpen(false);
    if (roleName === 'Admin' || roleName === 'Marketer') setReqLimit(0);
    else setReqLimit(100);
    if (roleName === 'Marketer') fetchChannels();
  };

  const fetchChannels = async () => {
    setChannelsLoading(true);
    await dispatch(GetAllchannalData());
    setChannelsLoading(false);
  };

  const toggleChannel = (name) => {
    setSelectedChannels(p => p.includes(name) ? p.filter(x => x !== name) : [...p, name]);
  };

  const selectAllChannels = () => {
    const allNames = channels.map(ch => ch.name || ch.channelName).filter(Boolean);
    setSelectedChannels(allNames);
  };

  const deselectAllChannels = () => setSelectedChannels([]);

  /* close dropdowns on outside click */
  useEffect(() => {
    const handler = (e) => {
      if (!e.target.closest('.rg-role-wrap'))  setRoleOpen(false);
      if (!e.target.closest('.rg-chan-wrap'))   { setChanOpen(false); setChanSearch(''); }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const validate = () => {
    const { name, email, phone, password, confirmPassword, role } = formData;
    if (!name.trim())                             { Notify('error','Name is required','error');              return false; }
    if (!email.trim())                            { Notify('error','Email is required','error');             return false; }
    if (!phone.trim())                            { Notify('error','Phone is required','error');             return false; }
    if (!password)                                { Notify('error','Password is required','error');          return false; }
    if (!confirmPassword)                         { Notify('error','Confirm password is required','error');  return false; }
    if (password !== confirmPassword)             { Notify('error','Passwords do not match','error');        return false; }
    if (!role)                                    { Notify('error','Role is required','error');              return false; }
    if (role==='Marketer' && selectedChannels.length===0) { Notify('error','At least one channel required','error'); return false; }
    return true;
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();
    if (!validate()) return;
    const fd = new FormData();
    fd.append('name',               formData.name);
    fd.append('email',              formData.email);
    fd.append('phone',              formData.phone);
    fd.append('password',           formData.password);
    fd.append('passwordConfirm',    formData.confirmPassword);
    fd.append('role',               formData.role);
    fd.append('profileImg',         selectedFile);
    fd.append('requestedleadslimit', (formData.role==='Admin'||formData.role==='Marketer') ? 0 : requestedLeadsLimit);
    if (formData.role==='Marketer') selectedChannels.forEach((ch,i) => fd.append(`channels[${i}]`, ch));
    setLoading(true);
    await dispatch(SignUp_Actionn(fd));
    setLoading(false);
  };

  useEffect(() => { if (resgetallchannal?.data) setChannels(resgetallchannal.data); }, [resgetallchannal]);

  useEffect(() => {
    if (ressignup?.status === 201) {
      setFormData({ name:'', email:'', phone:'', password:'', confirmPassword:'', role:'' });
      setSelectedChannels([]); setImage(null); setSelectedFile(''); setReqLimit(100);
      Notify('success','User registered successfully','success');
    }
  }, [ressignup]);

  const selectedRole   = ROLE_DATA.find(r => r.name === formData.role);
  const showLeadsLimit = formData.role && formData.role !== 'Admin' && formData.role !== 'Marketer';

  /* filtered channels for search */
  const filteredChannels = channels.filter(ch => {
    const name = ch.name || ch.channelName || '';
    return name.toLowerCase().includes(chanSearch.toLowerCase());
  });

  return (
    <div style={{ position:'fixed', top:50, left:sidebarWidth, right:0, bottom:0, transition:'left 0.25s cubic-bezier(0.4,0,0.2,1)', overflowY:'auto', background:C.bg, fontFamily:"'DM Sans','Segoe UI',sans-serif" }}>

      {/* ── Breadcrumb ── */}
      <div style={{ padding:'12px 32px', background:isDark?'#141929':C.bg, borderBottom:`1px solid ${C.border}`, display:'flex', alignItems:'center', gap:8, fontSize:12 }}>
        <Link to="/AllLeadsForAdmin" style={{ textDecoration:'none', color:C.sub, fontWeight:500 }}>Home</Link>
        <span style={{ color:C.sub, display:'flex' }}><IconArrow /></span>
        <Link to="/Users" style={{ textDecoration:'none', color:C.sub, fontWeight:500 }}>Users</Link>
        <span style={{ color:C.sub, display:'flex' }}><IconArrow /></span>
        <span style={{ color:C.text, fontWeight:600 }}>Create New Account</span>
      </div>

      <div style={{ padding:'32px', maxWidth:780 }}>

        {/* ── Page Title ── */}
        <div style={{ marginBottom:28 }}>
          <div style={{ fontSize:11, fontWeight:700, letterSpacing:'0.1em', textTransform:'uppercase', color:C.sub, marginBottom:4 }}>USER MANAGEMENT</div>
          <h1 style={{ fontSize:24, fontWeight:800, color:C.text, margin:0, letterSpacing:'-0.4px' }}>Create New Account</h1>
          <p style={{ fontSize:13, color:C.sub, margin:'6px 0 0' }}>Provision a new user account and configure their access level and permissions.</p>
        </div>

        {/* ── Main Card ── NOTE: no overflow:hidden so dropdowns show freely ── */}
        <div className="rg-card" style={{ background:C.card, border:`1px solid ${C.border}`, borderRadius:20, boxShadow:isDark?'none':'0 4px 24px rgba(0,0,0,0.07)' }}>

          {/* ════ Profile Identity ════ */}
          <div style={{ padding:'24px 28px', borderBottom:`1px solid ${C.border}`, borderRadius:'20px 20px 0 0', overflow:'hidden' }}>
            <SectionHeader icon={IconCamera} iconColor="29,78,216" title="Profile Identity" isDark={isDark} />
            <div style={{ display:'flex', alignItems:'center', gap:20 }}>
              <div style={{ position:'relative', flexShrink:0 }}>
                <div style={{ width:80, height:80, borderRadius:16, background:image?'transparent':(isDark?'#252d45':'#f0f4ff'), border:`2px solid ${C.border}`, overflow:'hidden', display:'flex', alignItems:'center', justifyContent:'center', color:C.sub }}>
                  {image ? <img src={image} alt="" style={{ width:'100%', height:'100%', objectFit:'cover' }} /> : <IconCamera />}
                </div>
                <label htmlFor="avatar-upload" style={{ position:'absolute', bottom:-4, right:-4, width:24, height:24, borderRadius:8, background:'#1d4ed8', border:`2px solid ${C.card}`, display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer', color:'#fff' }}>
                  <IconCamera />
                  <input id="avatar-upload" type="file" accept="image/*" style={{ display:'none' }} onChange={handleImage} />
                </label>
              </div>
              <div style={{ flex:1 }}>
                <div style={{ fontSize:14, fontWeight:700, color:C.text, marginBottom:4 }}>Profile Photo</div>
                <div style={{ fontSize:12, color:C.sub, marginBottom:12 }}>Upload a high-resolution professional portrait. Recommended: JPG or PNG, max 5MB.</div>
                <div style={{ display:'flex', gap:10, alignItems:'center' }}>
                  <label htmlFor="avatar-upload2" style={{ fontSize:12, fontWeight:700, color:'#1d4ed8', cursor:'pointer', textDecoration:'underline' }}>
                    {image ? 'Change Image' : 'Upload Image'}
                    <input id="avatar-upload2" type="file" accept="image/*" style={{ display:'none' }} onChange={handleImage} />
                  </label>
                  {image && (
                    <button onClick={() => { setImage(null); setSelectedFile(''); }} style={{ fontSize:12, fontWeight:700, color:'#ef4444', background:'none', border:'none', cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>
                      Remove
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* ════ Personal Information ════ */}
          <div style={{ padding:'24px 28px', borderBottom:`1px solid ${C.border}` }}>
            <SectionHeader icon={IconPerson} iconColor="29,78,216" title="Personal Information" isDark={isDark} />
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'16px 20px' }}>

              <Field label="Full Name" icon={IconPerson} isDark={isDark}>
                <input className="rg-input" placeholder="e.g. Jonathan Aris" value={formData.name}
                  onChange={handleInput('name')} onFocus={() => setFocused('name')} onBlur={() => setFocused(null)}
                  style={inputStyle('name')} />
              </Field>

              <Field label="Email Address" icon={IconMail} isDark={isDark}>
                <input className="rg-input" type="email" placeholder="j.aris@company.com" value={formData.email}
                  onChange={handleInput('email')} onFocus={() => setFocused('email')} onBlur={() => setFocused(null)}
                  style={inputStyle('email')} />
              </Field>

              <Field label="Phone Number" icon={IconPhone} isDark={isDark}>
                <input type='tel' className="rg-input" placeholder="+1 (555) 000-0000" value={formData.phone}
                  onChange={handleInput('phone')} onFocus={() => setFocused('phone')} onBlur={() => setFocused(null)}
                  style={inputStyle('phone')} />
              </Field>

              {/* Role custom select */}
              <div className="rg-role-wrap" style={{ position:'relative' }}>
                <label className="rg-label" style={{ color:C.sub }}>Job Role</label>
                <div style={{ position:'relative' }}>
                  <span style={{ position:'absolute', left:13, top:'50%', transform:'translateY(-50%)', color:C.sub, display:'flex', pointerEvents:'none', zIndex:1 }}><IconBadge /></span>
                  <div
                    onClick={() => setRoleOpen(o => !o)}
                    style={{ ...inputStyle('role'), padding:'11px 36px 11px 40px', borderRadius:10, border:`1.5px solid ${roleOpen?'#1d4ed8':C.inBdr}`, background:C.inputBg, color:formData.role?C.text:C.sub, fontSize:13, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'space-between', userSelect:'none', boxShadow:roleOpen?'0 0 0 3px rgba(29,78,216,0.1)':'none' }}
                  >
                    {selectedRole ? (
                      <span style={{ display:'flex', alignItems:'center', gap:8 }}>
                        <span>{selectedRole.icon}</span>
                        <span style={{ fontWeight:600 }}>{selectedRole.name}</span>
                      </span>
                    ) : 'Select a role...'}
                    <span style={{ display:'flex', color:C.sub, transform:roleOpen?'rotate(180deg)':'none', transition:'transform 0.2s' }}><IconChevron /></span>
                  </div>

                  {roleOpen && (
                    <div style={{ position:'absolute', top:'calc(100% + 6px)', left:0, right:0, zIndex:9999, background:isDark?'#1e2132':'#fff', border:`1px solid ${C.border}`, borderRadius:12, overflow:'hidden', boxShadow:isDark?'0 16px 40px rgba(0,0,0,0.5)':'0 8px 32px rgba(0,0,0,0.12)' }}>
                      {ROLE_DATA.map(r => (
                        <div key={r.name} className="rg-channel-opt"
                          style={{ background:formData.role===r.name?(isDark?'rgba(29,78,216,0.12)':'rgba(29,78,216,0.06)'):'transparent', color:formData.role===r.name?'#1d4ed8':C.text }}
                          onClick={() => handleRole(r.name)}>
                          <span style={{ display:'flex', alignItems:'center', gap:10 }}>
                            <span style={{ fontSize:16 }}>{r.icon}</span>
                            <span style={{ fontWeight:600 }}>{r.name}</span>
                          </span>
                          {formData.role===r.name && <span style={{ color:'#1d4ed8', display:'flex' }}><IconCheck /></span>}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>

            </div>
          </div>

          {/* ════ Security Credentials ════ */}
          <div style={{ padding:'24px 28px', borderBottom:`1px solid ${C.border}` }}>
            <SectionHeader icon={IconLock} iconColor="239,68,68" title="Security Credentials" isDark={isDark} />
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'16px 20px' }}>

              <Field label="Password" icon={IconLock} isDark={isDark}>
                <input className="rg-input" type={showPass?'text':'password'} placeholder="••••••••••••" value={formData.password}
                  onChange={handleInput('password')} onFocus={() => setFocused('pass')} onBlur={() => setFocused(null)}
                  style={{ ...inputStyle('pass'), paddingRight:40 }} />
                <button onClick={() => setShowPass(p=>!p)} style={{ position:'absolute', right:12, top:'50%', transform:'translateY(-50%)', background:'none', border:'none', cursor:'pointer', color:C.sub, display:'flex' }}>
                  {showPass ? <IconEyeOff /> : <IconEye />}
                </button>
              </Field>

              <Field label="Confirm Password" icon={IconLock} isDark={isDark}>
                <input className="rg-input" type={showConfirm?'text':'password'} placeholder="••••••••••••" value={formData.confirmPassword}
                  onChange={handleInput('confirmPassword')} onFocus={() => setFocused('confirm')} onBlur={() => setFocused(null)}
                  style={{ ...inputStyle('confirm'), paddingRight:40 }} />
                <button onClick={() => setShowConfirm(p=>!p)} style={{ position:'absolute', right:12, top:'50%', transform:'translateY(-50%)', background:'none', border:'none', cursor:'pointer', color:C.sub, display:'flex' }}>
                  {showConfirm ? <IconEyeOff /> : <IconEye />}
                </button>
              </Field>

            </div>
            <div style={{ marginTop:12, padding:'10px 14px', borderRadius:9, background:isDark?'rgba(29,78,216,0.07)':'rgba(29,78,216,0.04)', border:`1px solid ${isDark?'rgba(29,78,216,0.2)':'rgba(29,78,216,0.12)'}`, fontSize:12, color:isDark?'#93c5fd':'#1d4ed8', lineHeight:1.6 }}>
              Password must include at least 12 characters, one uppercase letter, one numerical digit, and one special character.
            </div>
          </div>

          {/* ════ Leads Limit ════ */}
          {showLeadsLimit && (
            <div className="rg-section" style={{ padding:'24px 28px', borderBottom:`1px solid ${C.border}` }}>
              <SectionHeader icon={IconNumbers} iconColor="34,197,94" title="Leads Request Limit" isDark={isDark} />
              <div style={{ padding:'18px 20px', borderRadius:12, background:isDark?'rgba(34,197,94,0.05)':'rgba(34,197,94,0.04)', border:`1px solid ${isDark?'rgba(34,197,94,0.2)':'rgba(34,197,94,0.15)'}` }}>
                <p style={{ fontSize:12, color:C.sub, margin:'0 0 16px' }}>Maximum number of leads this user can request from the data pool.</p>
                <div style={{ display:'flex', alignItems:'center', gap:14, marginBottom:16 }}>
                  <div style={{ position:'relative', width:180 }}>
                    <span style={{ position:'absolute', left:12, top:'50%', transform:'translateY(-50%)', color:'#22c55e', display:'flex', pointerEvents:'none' }}><IconNumbers /></span>
                    <input type="number" placeholder="100" value={requestedLeadsLimit}
                      onChange={(e) => { const v=parseInt(e.target.value); if(!isNaN(v)&&v>=0) setReqLimit(v); }}
                      onFocus={() => setFocused('leads')} onBlur={() => setFocused(null)}
                      style={{ width:'100%', padding:'10px 14px 10px 36px', borderRadius:9, border:`1.5px solid ${focused==='leads'?'#22c55e':C.inBdr}`, background:C.inputBg, color:C.text, fontSize:13, fontFamily:"'DM Sans',sans-serif", outline:'none', boxSizing:'border-box', boxShadow:focused==='leads'?'0 0 0 3px rgba(34,197,94,0.1)':'none' }} />
                  </div>
                  <span style={{ fontSize:12, color:C.sub }}>leads maximum</span>
                </div>
                <input type="range" min={0} max={1000} step={10} value={requestedLeadsLimit}
                  onChange={(e) => setReqLimit(Number(e.target.value))}
                  style={{ width:'100%', accentColor:'#22c55e', cursor:'pointer' }} />
                <div style={{ display:'flex', justifyContent:'space-between', fontSize:11, color:C.sub, marginTop:4 }}>
                  {['0','250','500','750','1000'].map(v => <span key={v}>{v}</span>)}
                </div>
                <div style={{ marginTop:12, fontSize:12, fontStyle:'italic', color:requestedLeadsLimit===0?'#ef4444':'#22c55e' }}>
                  {requestedLeadsLimit===0 ? '⚠️ User cannot request any leads' : `✅ User can request up to ${requestedLeadsLimit} leads`}
                </div>
              </div>
            </div>
          )}

          {/* ════ Channels (Marketer only) ════ */}
          {formData.role === 'Marketer' && (
            <div className="rg-section" style={{ padding:'24px 28px', borderBottom:`1px solid ${C.border}` }}>
              <SectionHeader icon={IconChannel} iconColor="168,85,247" title="Assign Channels" isDark={isDark} />

              <div style={{ padding:'16px 18px', borderRadius:12, background:isDark?'rgba(168,85,247,0.05)':'rgba(168,85,247,0.04)', border:`1px solid ${isDark?'rgba(168,85,247,0.2)':'rgba(168,85,247,0.15)'}` }}>

                {/* Selected chips */}
                {selectedChannels.length > 0 && (
                  <div style={{ display:'flex', flexWrap:'wrap', gap:7, marginBottom:14 }}>
                    {selectedChannels.map(ch => (
                      <span key={ch} className="rg-chip" style={{ background:isDark?'rgba(168,85,247,0.15)':'rgba(168,85,247,0.1)', color:'#a855f7', border:'1px solid rgba(168,85,247,0.25)' }}>
                        {ch}
                        <button onClick={() => toggleChannel(ch)} style={{ background:'none', border:'none', cursor:'pointer', color:'#a855f7', display:'flex', padding:0 }}>
                          <IconX />
                        </button>
                      </span>
                    ))}
                  </div>
                )}

                {/* Dropdown */}
                <div className="rg-chan-wrap" style={{ position:'relative' }}>
                  {/* Trigger */}
                  <div
                    onClick={() => { setChanOpen(o => !o); setChanSearch(''); }}
                    style={{ padding:'11px 40px 11px 14px', borderRadius:10, border:`1.5px solid ${chanOpen?'#a855f7':C.inBdr}`, background:C.inputBg, color:selectedChannels.length>0?'#a855f7':C.sub, fontSize:13, fontWeight:selectedChannels.length>0?600:400, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'space-between', userSelect:'none', position:'relative', boxShadow:chanOpen?'0 0 0 3px rgba(168,85,247,0.1)':'none', transition:'all 0.15s' }}
                  >
                    <span>{selectedChannels.length > 0 ? `${selectedChannels.length} channel(s) selected` : 'Choose channels…'}</span>
                    <span style={{ display:'flex', color:C.sub, transform:chanOpen?'rotate(180deg)':'none', transition:'transform 0.2s', position:'absolute', right:14 }}>
                      <IconChevron />
                    </span>
                  </div>

                  {/* Dropdown Panel */}
                  {chanOpen && (
                    <div style={{ position:'absolute', top:'calc(100% + 6px)', left:0, right:0, zIndex:99999, background:isDark?'#1e2132':'#fff', border:`1px solid ${isDark?'#2a2f45':'#e2e8f0'}`, borderRadius:14, overflow:'hidden', boxShadow:isDark?'0 20px 50px rgba(0,0,0,0.6)':'0 12px 40px rgba(0,0,0,0.15)' }}>

                      {/* Search */}
                      <div style={{ padding:'10px 12px', borderBottom:`1px solid ${isDark?'#2a2f45':'#f1f3f8'}`, position:'relative' }}>
                        <span style={{ position:'absolute', left:22, top:'50%', transform:'translateY(-50%)', color:C.sub, display:'flex', pointerEvents:'none' }}>
                          <IconSearch />
                        </span>
                        <input
                          autoFocus
                          placeholder="Search channels…"
                          value={chanSearch}
                          onChange={(e) => setChanSearch(e.target.value)}
                          style={{ width:'100%', padding:'8px 12px 8px 34px', borderRadius:8, border:`1px solid ${isDark?'#2a2f45':'#e2e8f0'}`, background:isDark?'#151827':'#f8fafc', color:C.text, fontSize:13, fontFamily:"'DM Sans',sans-serif", outline:'none', boxSizing:'border-box' }}
                        />
                      </div>

                      {/* Select All / Deselect All */}
                      <div style={{ padding:'8px 12px', borderBottom:`1px solid ${isDark?'#2a2f45':'#f1f3f8'}`, display:'flex', gap:8 }}>
                        <button
                          onClick={selectAllChannels}
                          style={{ flex:1, padding:'7px 10px', borderRadius:8, border:'none', cursor:'pointer', fontSize:12, fontWeight:700, fontFamily:"'DM Sans',sans-serif", background:isDark?'rgba(168,85,247,0.15)':'rgba(168,85,247,0.08)', color:'#a855f7', transition:'all 0.15s', display:'flex', alignItems:'center', justifyContent:'center', gap:5 }}
                          onMouseEnter={(e) => { e.currentTarget.style.background = isDark?'rgba(168,85,247,0.25)':'rgba(168,85,247,0.15)'; }}
                          onMouseLeave={(e) => { e.currentTarget.style.background = isDark?'rgba(168,85,247,0.15)':'rgba(168,85,247,0.08)'; }}
                        >
                          <IconCheck /> Select All ({channels.length})
                        </button>
                        <button
                          onClick={deselectAllChannels}
                          style={{ flex:1, padding:'7px 10px', borderRadius:8, border:`1px solid ${isDark?'#2a2f45':'#e2e8f0'}`, cursor:'pointer', fontSize:12, fontWeight:700, fontFamily:"'DM Sans',sans-serif", background:'transparent', color:C.sub, transition:'all 0.15s', display:'flex', alignItems:'center', justifyContent:'center', gap:5 }}
                          onMouseEnter={(e) => { e.currentTarget.style.background = isDark?'rgba(255,255,255,0.06)':'#f1f5f9'; }}
                          onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
                        >
                          <IconX /> Deselect All
                        </button>
                      </div>

                      {/* Options */}
                      <div className="rg-chan-scroll" style={{ maxHeight:220, overflowY:'auto' }}>
                        {channelsLoading ? (
                          <div style={{ padding:18, textAlign:'center', color:C.sub, fontSize:13 }}>
                            <div style={{ width:20, height:20, borderRadius:'50%', border:`2px solid ${isDark?'#2a2f45':'#e2e8f0'}`, borderTopColor:'#a855f7', animation:'rg-spin 0.7s linear infinite', margin:'0 auto 8px' }} />
                            Loading channels…
                          </div>
                        ) : filteredChannels.length === 0 ? (
                          <div style={{ padding:16, textAlign:'center', color:C.sub, fontSize:13 }}>
                            {chanSearch ? `No channels match "${chanSearch}"` : 'No channels available'}
                          </div>
                        ) : filteredChannels.map(ch => {
                          const name = ch.name || ch.channelName;
                          const sel  = selectedChannels.includes(name);
                          return (
                            <div key={ch._id||ch.id} className="rg-channel-opt"
                              style={{ background:sel?(isDark?'rgba(168,85,247,0.12)':'rgba(168,85,247,0.06)'):'transparent', color:sel?'#a855f7':C.text }}
                              onClick={() => toggleChannel(name)}
                            >
                              <span style={{ fontWeight:sel?700:500 }}>{name}</span>
                              {sel && <span style={{ color:'#a855f7', display:'flex' }}><IconCheck /></span>}
                            </div>
                          );
                        })}
                      </div>

                      {/* Footer count */}
                      <div style={{ padding:'8px 14px', borderTop:`1px solid ${isDark?'#2a2f45':'#f1f3f8'}`, display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                        <span style={{ fontSize:11, color:C.sub }}>
                          {filteredChannels.length} result{filteredChannels.length!==1?'s':''}
                          {chanSearch && ` for "${chanSearch}"`}
                        </span>
                        <span style={{ fontSize:11, fontWeight:700, color:'#a855f7' }}>
                          {selectedChannels.length} / {channels.length} selected
                        </span>
                      </div>

                    </div>
                  )}
                </div>

                {/* Status */}
                <div style={{ marginTop:10, fontSize:12, fontStyle:'italic', color:selectedChannels.length===0?'#ef4444':'#a855f7' }}>
                  {selectedChannels.length===0
                    ? '⚠️ Please select at least one channel'
                    : `✅ ${selectedChannels.length} channel(s) assigned`}
                </div>
              </div>
            </div>
          )}

          {/* ════ Footer Actions ════ */}
          <div style={{ padding:'18px 28px', display:'flex', alignItems:'center', justifyContent:'flex-end', gap:10, borderRadius:'0 0 20px 20px' }}>
            <Link to="/Users" style={{ textDecoration:'none' }}>
              <button
                style={{ padding:'11px 24px', borderRadius:10, border:'none', cursor:'pointer', fontSize:13, fontWeight:700, fontFamily:"'DM Sans',sans-serif", background:isDark?'rgba(255,255,255,0.07)':'#f1f5f9', color:isDark?'#d1d5db':'#374151', transition:'all 0.15s' }}
                onMouseEnter={(e) => { e.currentTarget.style.background=isDark?'rgba(255,255,255,0.12)':'#e2e8f0'; }}
                onMouseLeave={(e) => { e.currentTarget.style.background=isDark?'rgba(255,255,255,0.07)':'#f1f5f9'; }}
              >
                Cancel
              </button>
            </Link>

            <button
              onClick={handleSubmit} disabled={loading}
              style={{ padding:'11px 28px', borderRadius:10, border:'none', cursor:loading?'not-allowed':'pointer', fontSize:13, fontWeight:700, fontFamily:"'DM Sans',sans-serif", background:loading?'rgba(29,78,216,0.5)':'linear-gradient(135deg,#1e40af,#1d4ed8)', color:'#fff', transition:'all 0.2s', boxShadow:loading?'none':'0 4px 14px rgba(29,78,216,0.4)', display:'inline-flex', alignItems:'center', gap:8, opacity:loading?0.75:1 }}
              onMouseEnter={(e) => { if(!loading) e.currentTarget.style.transform='translateY(-1px)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.transform='translateY(0)'; }}
            >
              {loading ? <><div className="rg-spin" />Creating…</> : 'Create Account'}
            </button>
          </div>

        </div>

        {/* Footer */}
        <footer style={{ marginTop:24, fontSize:11, color:isDark?'#374151':'#d1d5db', textAlign:'center' }}>
          © 2026 Realatix CRM. Smart CRM that connects customers, data, and sales in one safe place.
        </footer>
      </div>
    </div>
  );
};
